export default __webpack_public_path__ + "static/top-03e303c42920cd5634868cf7513c91ea.webp";